/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Linking, StyleSheet, Text, TouchableOpacity } from 'react-native';
import {
  buildWhatsAppUrl,
  LOGIN_ACCESS_HELP_WHATSAPP_MESSAGE,
  SUPPORT_WHATSAPP_DISPLAY,
} from '@shared/support';
import { authFormUi } from './authFormUi';

type Props = {
  /** testID del botón */
  testID?: string;
  /** Estilo del label (proto login usa muted). */
  muted?: boolean;
};

/** CTA de urgencia cuando el usuario no puede entrar / el enlace de recovery falló. */
export function AuthWhatsAppHelpLink({ testID = 'auth.whatsapp-help', muted = true }: Props) {
  const open = () => {
    void Linking.openURL(buildWhatsAppUrl(LOGIN_ACCESS_HELP_WHATSAPP_MESSAGE));
  };

  return (
    <TouchableOpacity
      onPress={open}
      accessibilityRole="button"
      accessibilityLabel={`Escribinos por WhatsApp al ${SUPPORT_WHATSAPP_DISPLAY}`}
      testID={testID}
    >
      <Text style={[muted ? authFormUi.linkLabelMuted : authFormUi.linkLabel, styles.label]}>
        ¿No podés entrar? WhatsApp de urgencia
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  label: {
    textAlign: 'left',
  },
});
